import React, { useState, useEffect } from "react";
import { TextField, Button, MenuItem, Menu, Tooltip } from "@mui/material";
import { Get_One_Nested_Prop_From_MongoDB } from "../../../api/Get_One_Nested_Prop_From_MongoDB";
import { useParams } from "react-router-dom";
import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";
import removeUnderscores from "../../../../functions/removeUnderscores";
import { StudentuseAuth } from "../../../security/StudentUseAuth";
import { Student_Get_One_Nested_Prop_From_MongoDB } from "../../../api/Student_Get_One_Nested_Prop_From_MongoDB";
import { Student_Update_To_MongoDB_By_ID } from "../../../api/Student_Update_To_MongoDB_By_ID";
import { Link } from "react-router-dom";
import SEFChangePage from "../../../components/ChangePage/SEFChangePage";
import TextFieldForObjectState from "../../../components/Questions/TextFields/TextFieldForObjectState";

import SelectFieldForObjectState from "../../../components/Questions/TextFields/SelectFieldForObjectState";
import CheckConditions from "../../../components/Questions/CheckConditions";
import { Arr_MedicationsInfo } from "../../../../arrays/SEF/Arr_MedicationsInfo";
import DisplayTextField from "../../../components/Questions/DisplayTextField";
import getArrayOfQuestionsAndNeededToSubmit from "../../../components/Questions/GetUsefulArrays/getArrayOfQuestionsAndNeededToSubmit";
import getArrayOfNeededToSubmit from "../../../components/Questions/GetUsefulArrays/getArrayOfNeededToSubmit";

function ViewSEFMedicationsInfo() {
  const { id } = useParams();
  const { logoutStudent } = StudentuseAuth();

  const [formInfo, setformInfo] = useState({});
  //Get all questions for this page
  const { arrayOfQuestions, neededToSubmit } =
    getArrayOfQuestionsAndNeededToSubmit(
      "MedicationsInfo",
      formInfo,
      Arr_MedicationsInfo
    );

  //

  const isFormComplete = neededToSubmit.length === 0;

  const [PageButtonStatus, setPageButtonStatus] = useState(false);

  const [SEFProgress, setSEFProgress] = useState({
    MedicationsInfo: "",
  });

  const [BasicformInfo, setBasicformInfo] = useState({});

  useEffect(() => {
    Student_Get_One_Nested_Prop_From_MongoDB(
      "Registers_2025",
      "All",
      localStorage.getItem("Student_id"),
      "SEFMedicationsInfo",
      setformInfo,
      logoutStudent
    );
    Student_Get_One_Nested_Prop_From_MongoDB(
      "Registers_2025",
      "All",
      localStorage.getItem("Student_id"),
      "SEFProgress",
      setSEFProgress,
      logoutStudent
    );
    Student_Get_One_Nested_Prop_From_MongoDB(
      "Registers_2025",
      "All",
      localStorage.getItem("Student_id"),
      "BasicInfo",
      setBasicformInfo,
      logoutStudent
    );
  }, []);

  let AccomText = <p>Loading...</p>;

  if (
    BasicformInfo.ProgrammeVarient &&
    BasicformInfo.ProgrammeVarient.toLowerCase().includes("accom")
  ) {
    AccomText = (
      <p>
        All medication will be stored by InvestIN under the care of our staff.
        You must not send your student with any non-essential medication that
        they have not been prescribed by a doctor, this includes vitamins and
        supplements and herbal medicine. InvestIN staff and the on-site nurse
        will store daily medications and painkillers such as paracetamol, cold &
        flu etc., should your student require anything during their experience.
        The only medication that students will be allowed to store themselves
        are asthma inhalers, EpiPens or any other life-saving medication which
        would be appropriate for students to keep with them at all times.
        <br></br>
        <br></br>
        Students bringing prescribed medication with them must inform InvestIN
        of this on the student’s enrolment form, or by email if they begin
        taking medication after their enrolment form has been approved. You can
        send this information to info@investin.org and a member of the team will
        be in touch to update the student’s form.
        <br></br>
        <br></br>
        Please note that InvestIN can only accept medication in its original
        packaging, or in suitable packaging with the original doctor’s note
        detailing the prescription. Any medication that falls out of this
        description cannot be brought onsite or stored by InvestIN and a new
        prescription will need to be obtained
      </p>
    );
  } else if (
    BasicformInfo.ProgrammeVarient &&
    !BasicformInfo.ProgrammeVarient.toLowerCase().includes("accom")
  ) {
    AccomText = (
      <p>
        Non-residential students must look after their own medication. This
        includes life-saving medications and daily prescribed medications if
        they are required during programme hours (10.30am-5pm).
        <br></br>
        <br></br>
        InvestIN staff will store daily medications and painkillers such as
        paracetamol, cold & flu etc., should your student require anything
        during their experience.
        <br></br>
        <br></br>
        Students bringing prescribed medication with them must inform InvestIN
        of this on the student’s enrolment form, or by email if they begin
        taking medication after their enrolment form has been approved. You can
        send this information to info@investin.org and a member of the team will
        be in touch to update the student’s form
      </p>
    );
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setformInfo((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const [status, setStatus] = useState(false);

  const handleSaveProgress = () => {
    Student_Update_To_MongoDB_By_ID(
      {
        SEFMedicationsInfo: formInfo,
        "SEFProgress.MedicationsInfo": "In_Progress",
      },
      "Registers_2025",
      "All",
      setStatus,
      localStorage.getItem("Student_id"),
      "Your progress has been saved, you may now navigate to another page using the buttons at the bottom or close this tab",
      logoutStudent
    );
    setPageButtonStatus(true);
  };

  //If all values in every prop of formInfo are "No", let ThisPageSubmit = "Complete"
  let ThisPageSubmitValue = "Awaiting_Review";
  if (Object.values(formInfo).every((val) => val === "No")) {
    ThisPageSubmitValue = "Complete";
  }

  const handleSubmit = () => {
    Student_Update_To_MongoDB_By_ID(
      {
        SEFMedicationsInfo: formInfo,
        "SEFProgress.MedicationsInfo": ThisPageSubmitValue,
      },
      "Registers_2025",
      "All",
      setStatus,
      localStorage.getItem("Student_id"),
      "This page has been submitted, you may now navigate to another page using the buttons at the bottom or close this tab",
      logoutStudent
    );
    setSEFProgress({
      MedicationsInfo: "Complete",
    });
    setPageButtonStatus(true);
  };

  let Arr_Topics = [
    {
      Topic: "Medication",
      ask: 0,
      start: 1,
      end: 18,
      ask_title: "MedicationsInfo_other_prescribed_medication_1",
    },
    {
      Topic: "Medication",
      ask: 19,
      start: 20,
      end: 37,
      ask_title: "MedicationsInfo_other_prescribed_medication_2",
    },
  ];

  return (
    <div className="view-basic-info-container">
      <h1>Summer Information</h1>
      {AccomText}
      {SEFProgress &&
      SEFProgress.MedicationsInfo &&
      (SEFProgress.MedicationsInfo === "Complete" ||
        SEFProgress.MedicationsInfo === "Awaiting_Review") ? (
        <strong>
          If you need to make further changes, please contact InvestIN at
          info@investin.org or speak to your known contact
        </strong>
      ) : (
        ""
      )}
      <form className="view-basic-info-form">
        <h2>Medications Info</h2>
        <p>
          Health, well-being and safety information for each student (including
          medications){" "}
          <b>
            <u>must</u>
          </b>{" "}
          be completed by the student’s parent(s) or legal guardian(s) to ensure
          we have accurate, shared knowledge of the student. Parent(s) or legal
          guardian(s) may only use an Education Consultant or interpreter for
          translation purposes for this section.
          <br></br>
          <br></br>
          We have asked about each student’s medication(s) throughout this form,
          and this section will ask specifically about other medications not
          previously mentioned (such as Accutane).
          <br></br>
          <br></br>
          The following questions will assist InvestIN in understanding each
          student’s medical history and specific needs during the programme.
          Please read each question carefully and answer with as much detail as
          required. For the avoidance of doubt, we ask that you use the red,
          amber, green (RAG), and blue, rating guidance below for each question:
          <br></br>
          <br></br>
          <div
            className="text-left"
            style={{ outline: "1px solid red", padding: "10px" }}
          >
            • Red - the student is likely to require urgent or life-saving
            treatment should they become unwell or the condition (such as an
            allergy) be triggered.
            <br></br>• Amber - the student may require urgent care but can
            generally manage their symptoms if they become unwell or the
            condition (such as asthma) is triggered.
            <br></br>• Green - the student is unlikely to require support from a
            healthcare provider should they become unwell, they might require
            over-the-counter medicines from InvestIN staff but can manage their
            symptoms well.
            <br></br>• Blue – this is for information only. The student is very
            unlikely to need any support with this and symptoms are minor;
            therefore, unlikely to impact their learning or residential
            experience.
          </div>
        </p>
        {Arr_Topics.map((Obj) => (
          <>
            <br></br>
            <DisplayTextField
              formInfo={formInfo}
              handleChange={handleChange}
              Object={Arr_MedicationsInfo[Obj.ask]}
            />{" "}
            {formInfo[Obj.ask_title] === "Yes" &&
              Array.from(
                { length: Obj.end - Obj.start + 1 },
                (_, i) => Obj.start + i
              ).map((i) => (
                <>
                  <DisplayTextField
                    formInfo={formInfo}
                    handleChange={handleChange}
                    Object={Arr_MedicationsInfo[i]}
                  />
                </>
              ))}
            <br></br>
            <br></br>
          </>
        ))}
        <br></br>
        {/* ------------------------- */}
        <SEFChangePage
          Page={"MedicationsInfo"}
          PageButtonStatus={PageButtonStatus}
        />
        {isFormComplete ? (
          <></>
        ) : (
          <table>
            <thead>
              <tr>
                <th>
                  You can save this page at any point. To submit this page,
                  please complete the following questions first:
                </th>
              </tr>
            </thead>
            <tbody>
              {neededToSubmit.map((Obj) => {
                return (
                  <tr key={Obj.name}>
                    <td>{Obj.label}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}{" "}
        <h3>
          Once this page is completed and you have completed every question,
          please click "Submit" to complete the page and send it for review by
          InvestIN. Otherwise, click "Save" if you are not ready to complete the
          page and wish to return later to make changes
        </h3>
        <div className="view-basic-info-buttons">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSaveProgress}
            disabled={
              status ||
              (SEFProgress &&
                SEFProgress.MedicationsInfo &&
                (SEFProgress.MedicationsInfo === "Complete" ||
                  SEFProgress.MedicationsInfo === "Awaiting_Review")) ||
              Object.keys(formInfo).length === 0
            }
          >
            Save Progress
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleSubmit}
            disabled={
              !isFormComplete ||
              status ||
              (SEFProgress &&
                SEFProgress.MedicationsInfo &&
                (SEFProgress.MedicationsInfo === "Complete" ||
                  SEFProgress.MedicationsInfo === "Awaiting_Review")) ||
              Object.keys(formInfo).length === 0
            }
          >
            Submit
          </Button>
        </div>
      </form>
    </div>
  );
}

export default ViewSEFMedicationsInfo;
